import React, { useContext } from 'react';
import { JsxRenderer, TranslationsContext } from '@telia-common-components/shared';
import { Card, CardContent, Grid, GridColumn, Heading, Icon, Separator } from 'telia-front-react';
import { TELIA_TV_NETFLIX_PREMIUM } from '../util/TvServicesUtil';
export const NetflixAppCard = (props) => {
    const { productOfferingCode } = props;
    const { translate } = useContext(TranslationsContext);
    const salesArguments = [
        {
            text: translate(`netflixModal.${productOfferingCode}.resolution`),
            iconRef: 'service-tv-hd',
        },
        {
            text: translate(`netflixModal.${productOfferingCode}.viewerSlots`),
            iconRef: productOfferingCode === TELIA_TV_NETFLIX_PREMIUM ? 'viewslot-4' : 'viewslot-2',
        },
    ];
    if (productOfferingCode === TELIA_TV_NETFLIX_PREMIUM) {
        salesArguments.push({
            text: translate(`netflixModal.surroundSound`),
            iconRef: 'sound',
        });
    }
    return (React.createElement(Card, { padding: "medium" },
        React.createElement(CardContent, { background: 'neutral-bg-level-1' },
            React.createElement(Separator, { color: "invisible", spacing: "small" }),
            React.createElement(Icon, { modifiers: '#logo-netflix', style: { color: '#E50914' }, size: "xxl" }),
            React.createElement(Separator, { color: "invisible", spacing: "xsmall" }),
            React.createElement(Heading, { className: "h3" }, translate(`netflixModal.${productOfferingCode}.title`)),
            React.createElement(Separator, { color: "invisible", spacing: "xsmall" }),
            React.createElement("div", null, salesArguments.map((salesArgument, i) => (React.createElement(Grid, { key: i, horizontalGutter: "smedium", verticalGutter: "none", noWrap: true, gutter: "small" },
                React.createElement(GridColumn, { width: ['min-xs'], align: ['middle-xs'] },
                    React.createElement(Icon, { modifiers: `#${salesArgument.iconRef}`, size: "sm" })),
                React.createElement(GridColumn, { width: ['max-xs'], align: ['middle-xs'] },
                    React.createElement(JsxRenderer, { jsx: salesArgument.text })))))))));
};
